export default __webpack_public_path__ + "beco-short.png";